import { render, staticRenderFns } from "./LicenseRecommendChips.vue?vue&type=template&id=75a0c284&scoped=true"
import script from "./LicenseRecommendChips.vue?vue&type=script&setup=true&lang=ts"
export * from "./LicenseRecommendChips.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LicenseRecommendChips.vue?vue&type=style&index=0&id=75a0c284&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a0c284",
  null
  
)

export default component.exports